import type { Editor } from "@tiptap/core";

export type RichTextToolbarActiveState = {
  isBold: boolean;
  isItalic: boolean;
  isStrong: boolean;
  isEmphasized: boolean;
  isBulletList: boolean;
  isOrderedList: boolean;
};

export const selectRichTextToolbarActiveState = (snapshot: {
  editor: Editor | null;
}): RichTextToolbarActiveState | null => {
  const { editor } = snapshot;
  if (editor == null) {
    return null;
  }
  return {
    isBold: editor.isActive("bold"),
    isItalic: editor.isActive("italic"),
    isStrong: editor.isActive("bold"),
    isEmphasized: editor.isActive("italic"),
    isBulletList: editor.isActive("bulletList"),
    isOrderedList: editor.isActive("orderedList"),
  };
};
